import type { Router } from 'vue-router'
import { sentryCapture } from '@/utils/sentry'

export const listenRemoteRoutes = (router: Router) => {
  document.addEventListener('remoteSuccess', ((event: CustomEvent) => {
    try {
      const {
        detail: { name, query, params }
      } = event
      const { currentRoute } = router

      if (currentRoute?.value?.name) {
        query.from = currentRoute?.value?.name
      }

      router.push({
        name,
        query,
        params
      })
    } catch (err) {
      sentryCapture(err)
    }
  }) as any)
}
